import { TxKeyPath } from '@i18n/index';

import { ImmerStateCreator } from '../store.type';

import {
  addErrorNotificationAction,
  AddErrorNotificationActionPayloadType,
  addSuccessNotificationAction,
  AddSuccessNotificationActionPayloadType,
  deleteErrorNotificationAction,
  deleteSuccessNotificationAction,
} from './notification.action';

export type NotificationSliceType = {
  error?: {
    id: string
    description?: string
    descriptionTranslate?: TxKeyPath
    messageTranslate: TxKeyPath
    duration: number
  }
  success?: {
    id: string
    description?: string
    descriptionTranslate?: TxKeyPath
    messageTranslate: TxKeyPath
    duration: number
  }
  addErrorNotificationAction: (payload?: AddErrorNotificationActionPayloadType) => void
  addSuccessNotificationAction: (payload: AddSuccessNotificationActionPayloadType) => void
  deleteErrorNotificationAction: () => void
  deleteSuccessNotificationAction: () => void
};

const notificationSlice: ImmerStateCreator<NotificationSliceType> = (set) => ({
  error: undefined,
  success: undefined,
  addErrorNotificationAction: (payload) => addErrorNotificationAction(set)(payload),
  addSuccessNotificationAction: (payload) => addSuccessNotificationAction(set)(payload),
  deleteErrorNotificationAction: () => deleteErrorNotificationAction(set)(),
  deleteSuccessNotificationAction: () => deleteSuccessNotificationAction(set)(),
});

export default notificationSlice;
